import React from 'react';
import ReactDOMServer from "react-dom/server";
import Toast from "shared/toast";
import WarningList from "shared/virtual_line_modal/components/WarningList";

export default function bulkErrorToast(errors) {
  const plural = errors.length > 1;

  return Toast.error({
    title: `Error moving Promo Number${plural ? "s" : ""}`,
    message: messageWithErrors(errors, plural),
    sticky: true
  });
}

function messageWithErrors(errors, plural) {
  const message = `The following Promo Number${plural ? "s were" : " was"} not able to be moved <hr>`;
  const formattedErrors = ReactDOMServer.renderToString(<WarningList warnings={errors} />);
  return message + formattedErrors;
}
